import { useNavigate } from "react-router-dom";
import { HeaderTitle } from "../../components/header/Header";
import Container from "../../components/layout/Container";
import { NavigatePath } from "../../functions/Navigate.Goback";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PADDING_MAIN,
  STYLE_SPACE_GRAY_MENU,
} from "../../utils/useStyle";
import { CardGrayMenu } from "../../components/card/CardMain";
import { useEffect } from "react";
import { first_reload } from "./functions/firstLoad";
import { useBalanceStore } from "../../_store/balanceStore";
import { useLegacyStore } from "../../_store/legacyStore";

const InsuarancePlanMain = () => {
  const navigate = useNavigate();
  const balanceData = useBalanceStore((state) => state.balanceData);

  const onClickToWebsite = () => {
    window.open("https://assurewealth.co.th/", "_blank");
  };

  const hasAccidentInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) =>
      thisItem?.options_expenses_fixed === "expenses_insuarant_accident"
  );
  const hasFireInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_fire"
  );
  const hasCarInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_car"
  );

  return (
    <Container>
      <div id="first_reload" className="">
        <div className={`${STYLE_MARGIN_TOP_PARENT} `}>
          <HeaderTitle
            title="วางแผนประกัน"
            isGoback
            onClickGoBack={() => {
              NavigatePath(navigate, "/");
            }}
          />
          <div className={`${STYLE_SPACE_GRAY_MENU} ${STYLE_PADDING_MAIN}`}>
            <CardGrayMenu
              img={"../images/homewithheart.png"}
              title={"ประกันคุ้มครองค่าใช้จ่ายเพื่อการดำรงชีพของครอบครัว"}
              onClick={() => {
                navigate("/insuranceplan/family");
              }}
            />
            <CardGrayMenu
              img={"../images/risk_diabled.svg"}
              title={"ประกันคุ้มครองกรณีทุพพลภาพ"}
              onClick={() => {
                navigate("/insuranceplan/disabled");
              }}
            />
            <CardGrayMenu
              img={"../images/sick_insuarance_all.png"}
              title={"ประกันสุขภาพ"}
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/risk_accident.svg"}
              title={"ประกันอุบัติเหตุ"}
              title2={
                hasAccidentInsurance
                  ? <p>ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่ เบี้ยหลักพันคุ้มครองหลักแสน เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย ตามวงเงินประกัน <u>ดูรายละเอียดเพิ่มเติม</u></p>
                  : <p>ประกันอุบัติเหตุเบี้ยหลักพันต่อปีคุ้มครองหลักแสน มีแล้วอุ่นใจ เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย ตามวงเงินประกัน <u>ดูรายละเอียดเพิ่มเติม</u></p>
              }
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/risk_fire.svg"}
              title2={
                hasFireInsurance
                  ? <p>ควรทบทวนกรมธรรม์ ประกันทรัพย์สินและอัคคีภัย ว่าได้รับความคุ้มครองเหมาะสมกับมูลค่าทรัพย์สินในปัจจุบันหรือไม่ มิฉะนั้นหากเกิดความเสียหายมา บริษัทจะจ่ายตามสัดส่วน ไม่ใช่มูลค่าความเสียหายที่แท้จริง <u>ดูรายละเอียดเพิ่มเติม</u></p>
                  : <p>ทรัพย์สินของคุณยังไม่มีการบริหารความเสี่ยงด้วยประกันอัคคีภัย เบี้ยหลักพันคุ้มครองหลักล้าน <u>ดูรายละเอียดเพิ่มเติม</u></p>
              }
              title={"ประกันอัคคีภัย"}
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/car_insuarance_all.png"}
              title2={
                hasCarInsurance
                  ? <p>ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่ เบี้ยหลักพันคุ้มครองหลักแสน เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย ตามวงเงินประกัน <u>ดูรายละเอียดเพิ่มเติม</u></p>
                  : <p>คุณลืมกรอกข้อมูลค่าเบี้ยประกันรถยนต์หรือไม่ ถ้าคุณไม่ได้ซื้อประกันรถยนต์ภาคบังคับ/ภาคสมัครใจ เกิดเหตุไม่คาดฝันขึ้นมา โดนฟ้องร้องหมดตัวเลยนะครับ 
                  เบี้ยประกันภาคบังคับหลักร้อยต่อปีคุ้มครองหลักแสน ประกันภาคสมัครใจ  เบี้ยหลักพันคุ้มครองหลักแสน <u>ดูรายละเอียดเพิ่มเติม</u></p>
              }
              title={"ประกันรถยนต์"}
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/two_hearts.png"}
              title2={
                "แนะนำ ประกันชดเชยโรคร้ายแรง / ประกันการเดินทางต่างประเทศ และหากทำธุรกิจการศึกษาประกันภัยทางธุรกิจก็จำเป็น"
              }
              title={"ประกันอื่น ๆ"}
              onClick={onClickToWebsite}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default InsuarancePlanMain;
